import { Component } from '@angular/core';

@Component({
  selector: 'app-services-icon-svg',
  standalone: true,
  template: `
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99998 15.7163L4.90864 13.625H1.98078C1.60193 13.625 1.28125 13.4937 1.01875 13.2312C0.75625 12.9687 0.625 12.648 0.625 12.2692V2.23077C0.625 1.85192 0.75625 1.53125 1.01875 1.26875C1.28125 1.00625 1.60193 0.875 1.98078 0.875H12.0192C12.398 0.875 12.7187 1.00625 12.9812 1.26875C13.2437 1.53125 13.375 1.85192 13.375 2.23077V12.2692C13.375 12.648 13.2437 12.9687 12.9812 13.2312C12.7187 13.4937 12.398 13.625 12.0192 13.625H9.09132L6.99998 15.7163ZM1.98078 12.5H5.3644L6.99998 14.1356L8.63556 12.5H12.0192C12.0865 12.5 12.1418 12.4783 12.1851 12.4351C12.2283 12.3918 12.25 12.3365 12.25 12.2692V2.23077C12.25 2.16346 12.2283 2.10817 12.1851 2.06489C12.1418 2.02162 12.0865 1.99998 12.0192 1.99998H1.98078C1.91346 1.99998 1.85817 2.02162 1.81489 2.06489C1.77162 2.10817 1.74998 2.16346 1.74998 2.23077V12.2692C1.74998 12.3365 1.77162 12.3918 1.81489 12.4351C1.85817 12.4783 1.91346 12.5 1.98078 12.5ZM8.02546 8.27546L10.2884 7.24998L8.02546 6.22451L6.99998 3.96155L5.97451 6.22451L3.71155 7.24998L5.97451 8.27546L6.99998 10.5384L8.02546 8.27546Z"
        fill="#1C1B1F"
      />
    </svg>
  `,
})
export class ServicesIconSvgComponent {}
